import axios from 'axios';
//export const baseURL = 'https://mapi.ieh5.com'
export const baseURL = 'https://sapi.sphcxzt.com'
//export const baseURL = 'https://mapi.962646.com'


import {Message } from '@arco-design/web-react';
const axiosInstance = axios.create({
  baseURL
})
const platform = 1;
const version = 1;
// 添加请求拦截器
axiosInstance.interceptors.request.use(
	config => {
		const token = localStorage.getItem("token")
		//const token ='eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJ3eS5pZWg1LmNvbSIsImF1ZCI6Ind5LmllaDUuY29tIiwiaWF0IjoxNzg5NTQzMzI3LCJuYmYiOjE3ODk1NDMzMjcsImV4cCI6MTc5MjEzNTMyNywianRpIjp7ImlkIjozOTU2MCwib3BlcmF0ZV9pZCI6Mzk1NjAsInNpdGVfaWQiOjAsInBsYXRmb3JtIjoic2hpcGluaGFvIiwicGFzc3dvcmRfZWRpdF9zb3J0IjoxfX0.NitYDl0lTsk8P39bXpqoeHyOm_Ki3ifFJGmLJ2C9hvA'
		if (token) {
			if(config.url!=='/system/config?isToken=false'){
				config.headers.Authorization = `Bearer ${token}`
			}
		}
		if (config.method === 'post') {
			config.data = {
				platform: platform,
				version:version,
				...config.data
			}
		} else if (config.method === 'get') {
			config.params = {
				platform: platform,
				version:version,
				...config.params
			}
		}
		// 在最后必须return config
		return config
	},error => {
		console.log('error',error);
		if (error.response) {
		  // switch (error.response.status) {
		  //   case 401:
		  //     // 返回 401 清除token信息并跳转到登录页面
		  //     router.replace({
		  //       path: '/login',
		  //       query: {
		  //         redirect: router.currentRoute.fullPath
		  //       }
		  //     })
		  // }
		}
		return Promise.reject(error.response.data) // 返回接口返回的错误信息
	});

axiosInstance.interceptors.response.use(
    response => {
		if(response.data.code===0){
			return response;
		}else{
			if(response.data.code=='10404'){
				window.location.href = '/home/login';
			}else if(response.data.code=='80404'){
				
				if(response.config.url!='/order/statistics' && response.config.url!='/live_order/statistics'){
					Message.error(response.data.msg)
				}
				return response;
			}else{
				return response;
			}

		}
    },
    (error) => {
     
		const err = JSON.stringify(error);
		const errResponse = JSON.parse(err);
		if(errResponse.status==429){
			Message.error('请勿频繁请求')
		}
        return Promise.reject(error)
    }
)


export default axiosInstance;